import type { R2BAvailableBrandEntity } from "../../entity_types/r2bAvailableBrand";

export const r2b_available_v1: R2BAvailableBrandEntity = {
  token: "r2b_available_v1",
  type: "r2bAvailableBrand",
  name: "Vaughts",
  stagingBrandToken: "r2b_staging_vaughts",
  benefits: [
    {
      text: "Free Shipping with Insider",
      color: "teal",
    },
  ],
  newBadgeIndexes: [0],
  previouslySeen: true,
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
